const STORAGE_KEY = 'signup-voucher'

export default {
  resolve (queryVoucher) {
    if (queryVoucher) {
      sessionStorage.setItem(STORAGE_KEY, queryVoucher)
      return queryVoucher
    }
    return sessionStorage.getItem(STORAGE_KEY)
  },

  clear () {
    sessionStorage.removeItem(STORAGE_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/services/signup-voucher.js